export default __webpack_public_path__ + "static/media/DSC0067.ebfc82e4.jpg";